import React from 'react';

export type BaseButtonSize = 'sm' | 'md' | 'lg' | 'icon';

export interface IBaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: string;
  size?: BaseButtonSize;
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
  isSubmit?: boolean;
  // Variant and size configuration functions
  getVariantClass: (variant: string) => string;
  getSizeClass: (size: BaseButtonSize) => string;
  getBaseClasses: () => string;
  getDisabledClass: (disabled: boolean, isLoading: boolean) => string;
}

const BaseButton: React.FC<IBaseButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  isSubmit = false,
  className = '',
  disabled,
  type = isSubmit ? 'submit' : 'button',
  getVariantClass,
  getSizeClass,
  getBaseClasses,
  getDisabledClass,
  ...props
}) => {
  const variantClass = getVariantClass(variant);
  const sizeClass = getSizeClass(size);
  const baseClasses = getBaseClasses();
  const disabledClass = getDisabledClass(disabled || false, isLoading);
  const widthClass = fullWidth ? 'w-full' : '';

  const buttonClasses = [baseClasses, variantClass, sizeClass, disabledClass, widthClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <button type={type} className={buttonClasses} disabled={disabled || isLoading} {...props}>
      {!isLoading && leftIcon && <span className='mr-2'>{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className='ml-2'>{rightIcon}</span>}
    </button>
  );
};

export default BaseButton;
